import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { SessionActions } from '../../modules/session/session-controller/actions';
import { SessionSelectors } from '../../modules/session/session-controller/selectors';
import { SessionStates } from '../../modules/session/session-controller/states';
import { DropDownService } from '../../services/drop-down-service';
import { ReplaySubject, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ApiVisa } from 'blg-akaun-ts-lib';
import { Store } from '@ngrx/store';
import { SharedUtilitiesHelperFunctions } from '../helper-functions';

@Component({
  selector: 'app-select-multi-customer-drop-down',
  templateUrl: './select-multi-customer-drop-down.component.html',
  styleUrls: ['./select-multi-customer-drop-down.component.css']
})
export class SelectMultiCustomerDropDownComponent implements OnInit, OnDestroy {

  @Input() customer: FormControl;
  @Input() apiVisa: ApiVisa;
  @Input() selectedGuid: string;
  @Input() label = 'Customer';
  @Input() options: any;

  @Output() customerSelected = new EventEmitter<any>();

  serverSideFiltering = new FormControl();
  filteredOptions$: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
  selectedRow: any;
  rowData: any = [];
  key = "customer";

  protected _onDestroy = new Subject<void>();

  constructor(private dropDownService: DropDownService, 
    private readonly store: Store<SessionStates>
  ) { 
    
  }

  ngOnInit() {
    // set initial selection
    this.key = this.options['customer'];

    this.store.select(SessionSelectors.selectDropDownRowData).subscribe(resolved => {
      this.rowData = resolved?resolved[this.key]?resolved[this.key]:[]:[];
      if (this.rowData.length === 0) {
        this.getRowData();
      }
      else {
        this.filteredOptions$.next(this.rowData.slice());
      }
    })

    // listen for search field value changes
    this.serverSideFiltering.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filtering();
      });
  }

  ngOnChanges() {
    // console.log('ngOnChanges');
  }

  getRowData(keyword?) {
    if (!this.key) return;

    let formData = {
      "limit" : 50,
      "orderBy" : "name",
      "order" : "ASC",
      "keyword" : ( keyword ? keyword : '')
    }
    this.dropDownService.get(this.key, formData, this.apiVisa).subscribe(resolved => {
      this.rowData = [...this.rowData, ...resolved.data];
      this.rowData = SharedUtilitiesHelperFunctions.removeDuplicate(this.rowData, 'guid');
      
      // sorting
      const sorted = this.rowData.sort((a, b) => (a.name < b.name ? -1 : 1));

      this.store.dispatch(SessionActions.selectDropDownRowData({key: this.key, rowData: this.rowData}));
      
      //fill the drop down
      if (keyword) {
        this.filteredOptions$.next(resolved.data.slice());
      }
      else {
        this.filteredOptions$.next(this.rowData.slice());
      }
    });
  }

  filtering() {
    if (!this.rowData) {
      return;
    }

    // get the search keyword
    let search = this.serverSideFiltering.value;
    if (!search || search.length < 3) {
      this.filteredOptions$.next(this.rowData.slice());
      return;
    } else {
      search = search.toLowerCase();
      this.getRowData(search);
    }
  }

  onSelect(guid: string) {
    if (guid) {
      this.customer.patchValue(guid);
      this.selectedRow = this.rowData.find(row => row.guid === guid);
      this.customerSelected.emit(this.selectedRow);
    }
  }

  isRequired() {
    let value = this.options['required'];
    if (value === true || value === false) {
      return value;
    }
    else if (value) {
      return value.includes(true);
    }
    return false; 
  }

  isMultiple() {
    let value = this.options['multiple'];
    if (value === true || value === false) {
      return value;
    }
    else if (value) {
      return value.includes(true);
    }
    return false; 
  }

  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }

}
